import { createContext, useContext } from 'react';
import type { CardId, CardListId, CardListType, Sprint } from '../../model/types';

export type CardListContextProps = {
	cardCountExcludingSubtasks: number;
	cardIds: CardId[];
	cardListId: CardListId;
	isCollapsed: boolean;
	isFirstList: boolean;
	isMaxLimitReached: boolean;
	isMinLimitReached: boolean;
	maxColumnLimit: number | undefined;
	minColumnLimit: number | undefined;
	listName: string;
	sprintData: Sprint | undefined;
	type: CardListType;
	visibleCardAmount: number;
};

export const CardListContext = createContext<CardListContextProps | undefined>(undefined);

export const useCardListContext = () => {
	const context = useContext(CardListContext);

	if (!context) {
		throw new Error('useCardListContext must be used within a CardListContextProvider');
	}

	return context;
};
